module.exports = __webpack_public_path__ + "static/media/landing-docu-card.f64ea30b.svg";